import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ErrorTailorModule } from '@ngneat/error-tailor';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { QuillModule } from 'ngx-quill';
import { ServiceModule } from "src/app/services/service.module";
import { ComponentsModule } from "../common-components/components.module";
import { ObservationCommentCellComponent } from "./components/observation-comment-cell/observation-comment-cell.component";
import { ObservationCommentControllerModal } from "./components/observation-comment-controller-modal/observation-comment-controller-modal.component";
import { ObservationCommentFormComponent } from "./components/observation-comment-form/observation-comment-form.component";
import { ObservationCommentsIndicatorComponent } from "./components/observation-comments-indicator/observation-comments-indicator.component";
import { ObservationCommentsComponent } from "./components/observation-comments/observation-comments.component";
import { PaetepDirectiveModule } from "src/app/directives/paetep-directive.module";
import { PrintObservationCommentsComponent } from "./components/print-observation-comments/print-observation-comments.component";
import { DisplayCommentComponent } from './components/display-comment/display-comment.component';
import { DisplayAttachmentsComponent } from './components/display-attachments/display-attachments.component';
import { AttachmentButtonComponent } from './components/attachment-button/attachment-button.component';

import { EdlCommonComponentsModule, QuillEditorModule } from "@edl-development/edl-common";


@NgModule({
    declarations: [
        ObservationCommentCellComponent,
        ObservationCommentControllerModal,
        ObservationCommentFormComponent,
        ObservationCommentsComponent,
        ObservationCommentsIndicatorComponent,
        PrintObservationCommentsComponent,
        DisplayCommentComponent,
        DisplayAttachmentsComponent,
        AttachmentButtonComponent
    ],
    exports: [
        ObservationCommentCellComponent,
        ObservationCommentControllerModal,
        ObservationCommentFormComponent,
        ObservationCommentsComponent,
        ObservationCommentsIndicatorComponent,
        PrintObservationCommentsComponent,
        DisplayCommentComponent,
        DisplayAttachmentsComponent,
        AttachmentButtonComponent
    ],
    imports: [
        CommonModule,
        ComponentsModule,
        PaetepDirectiveModule,
        NgbModule,
        ServiceModule,
        FormsModule,
        ReactiveFormsModule,
        QuillModule,
        QuillEditorModule,
        EdlCommonComponentsModule,
        ErrorTailorModule
    ]
})
export class ObservationCommentsModule { }
